/**
 * @generated SignedSource<<ec663dd9af392e522a1df49c106e4697>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SplitDetailsModal_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SplitDetailsContent_viewer">;
  readonly " $fragmentType": "SplitDetailsModal_viewer";
};
export type SplitDetailsModal_viewer$key = {
  readonly " $data"?: SplitDetailsModal_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SplitDetailsModal_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SplitDetailsModal_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SplitDetailsContent_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "ab83de7e8535f8b3037051eef2bcb3bc";

export default node;
